
import { Component, EventEmitter, HostBinding, Input, Output, SkipSelf } from "@angular/core";
import { Observable,  zip as observableZip } from "rxjs";
import { ImmutableRedux } from "../../../redux/immutable-redux.service";
import { ReduxRequestsMap } from "../../../redux/redux-requests-map.service";
import { RowSelectionManagerDirective } from "../manager.directive";

@Component({
    selector: "row-selection-control-delete",
    templateUrl: "./delete.component.html",
})
export class RowSelectionControlDeleteComponent {
    @Input("buttonLabel") public buttonLabelInput = "Delete";
    @Input() public buttonIcon = "trash-can";
    @Input() public buttonType = "primary";
    @Input() public buttonSize: string;

    @Output() deleteActionComplete: EventEmitter<any> = new EventEmitter();

    @HostBinding("style.cursor") public cursorStyle = "pointer";

    constructor(
        public ngRedux: ImmutableRedux<any>,
        public reduxRequests: ReduxRequestsMap,
        @SkipSelf() public rowSelectionManager: RowSelectionManagerDirective,
    ) { }

    public get rootProp() {
        return this.rowSelectionManager.rootProp;
    }

    public get stateProp() {
        return this.rowSelectionManager.stateProp;
    }

    public get buttonLabel() {
        if (!!this.numSelected) {
            return `${this.buttonLabelInput} (${this.numSelected})`;
        } else {
            return this.buttonLabelInput;
        }
    }

    public get selectedDetailIds() {
        const ids = this.rowSelectionManager.selectedIds;
        return Object.keys(ids).filter((id) => ids[id]);
    }

    public get numSelected() {
        return this.selectedDetailIds.length;
    }

    public delete() {
        const deleteRequests = this.selectedDetailIds.map((id) => {
            return this.reduxRequests.within(this.stateProp).delete(id);
        });
        observableZip(...deleteRequests).subscribe((responses) => {
            this.deleteActionComplete.emit(responses);
            this.rowSelectionManager.dispatchDeselectAll();
        });
    }
}
